/***Main Model To Save WorkOrder Details */

import { CustomFieldsConfiguration } from '../shared/custom-fields/custom-fields-models';
import { Time } from '@angular/common';
export class workOrderDetails {
    customerId: number;
    pCustomerEntity: CustomerEntity;
    serviceAddress: number;
    CompanyId: number;
    ProjectId: number;
    ProjectMilestoneId: number;
    ProjectName: string;
    serviceAddressName: string;
    serviceAddrZip: string;
    billingAddress: number;
    billingContact: number;
    serviceContact: number;
    pEquipmentList: equipmentList[];
    pCustomerServAddress: CustomerAddressDetails;
    pCustomerServContact: CustomerContactDetails;
    pCustomerBillAddress: CustomerAddressDetails;
    pCustomerBillContact: CustomerContactDetails;
    pInstructions: Specialinfo[];
    pNotes: Specialinfo[];
    pJobDetails: JobDetails[];
    pJobPricing: JobPricing[];
    jobdetailspricing: JobDetailsPricing[];
    chkScheduled: boolean;
    isEquipment: boolean;
    reserveddate: string;
    reservetime: string;
    reservedId: string;
    ScheduleStartDate: string;
    ScheduleEndDate: string;
    CustScheduleStartDate: string;
    CustScheduleEndDate: string
    VendorId: number;
    customFields15: CustomFieldsConfiguration;
    customFields17: CustomFieldsConfiguration;
    customFields19: CustomFieldsConfiguration;
    customFields65: CustomFieldsConfiguration;
    changedbyCustomer: number;
    autofocusPriorityId: number;
    maxDurationPriorityId: number;
    isLookupEnabled: number;
    ActualContactName: string;
    SlaType: string;// SLA Priority level like , Equpment, customertype, worktype, manual - display tooltip
    SlaApplied: number;
    ExistingGroupId: number;
    QuoteOrderId?: number;
    chkAssignMe?: number;
    formList?: WoForms[];
    NoofTech?: number;
    IsNetwork?: number;
    IsInhouse?: number;
    IsField?: number;
    woFormAttachmentUniqueId?: number = 0;
}

export class WoForms {
    ChklistMastId: number;
    ChklistName: string;
    Description: string;
    TaskId: number;
    TaskNumber: number;
    questions: SaveDynamicChecklist;
    Mandatory?: number;
}




export class submitworkOrderDetails {
    customerId: number;
    CompanyId: number;
    ProjectId?: number;
    ProjectName?: string;
    ProjectMilestoneId?: number;
    VendorId?: number;
    pEquipmentList: equipmentList[];
    CustomerTypeId: number;
    pCustomerServAddress: CustomerAddressDetails;
    pCustomerServContact: CustomerContactDetails;
    pCustomerBillAddress: CustomerAddressDetails;
    pCustomerBillContact: CustomerContactDetails;
    pJobDetails: JobDetails[];
    pJobPricing: JobPricing[];
    pInstructions: Specialinfo[];
    pNotes: Specialinfo[];
    chkScheduled: number;
    isEquipment: number;
    loginId: number;
    ScheduleStartDate: string;
    ScheduleEndDate: string;
    CustScheduleStartDate: string;
    CustScheduleEndDate: string
    customFields: CustomFieldsConfiguration[];
    customFields17: CustomFieldsConfiguration;
    changedbyCustomer: number;
    autofocusPriorityId: number;
    maxDurationPriorityId: number;
    isLookupEnabled: number;
    CreatedSourceId?: number;
    UpdatedSourceId?: number;
    SlaApplied: number;
    QuoteOrderId?: number;
    chkAssignMe?: number;
    formList?: WoForms[];
    NoofTech?: number;
    woFormAttachmentUniqueId?: number = 0;
}

/**Autolookup select List Properties */
export class Customerlookupdetails {
    CustomerId: number;
    CustomerName: string;
    Phone1: string;
    CustomerType: string;
}
export class Customerdetails {
    CompanyID: number;
    CustomerId: number;
    CustomerName: string;
    AddressLine1: string;
    CustomerType: string;
    phone1: string;
    phone2: string;
    CustomerStatus: string;
    SortBy: string;
    OrderBy: string;
    startRecord: number;
    EndRecord: number;
    ContactName: string;
    ProjectName: string;
    Type: number;
    Search: string;
    Brand: string;
    Model: string;
    TagNo: string;
    SerialNo: string;
    Description: string;
    ProjectType: string;
    WBSno: string;
    PriorityName: string;
    AddressType: number;
    AddressName: string;
    MaxRoleGroup?: number;
    LoginId?: number;
    EnablePreferVendorForCustomer?: number;
    SearchText: string;
    Searchby: number;
}
export class CustomerDetailsListEntity {
    CustomerList: CustomerEntity[];
    TotalRecord: number;
}
export class filteroptions {
    constructor(public id: number,
        public name: string) { }
}
export class RecentWorkOrder {
    ScheduleDate: string;
    ScheduleStartDateTime: string;
    WoNumber: string;
    WoStatusId: number;
    WoStatus: string;
    JobNo: number;
    JobStatusId: number;
    JobStatus: string;
    WorkTaskId: number;
    WorkTask: string;
    WorkType: string;
    CreatedDate: string;
    CreatedBy: string;
    ClosedDate: string;
    TechName: string;
    IsPmOrder: number;
    WoCategory: string;
    InvoiceDate: string;
    InvoiceById: number;
    InvoiceBy: string;
    ServiceAddress: string;
    WoJobId: number;
    TaskNo: number;
    CompletedDateTime: string
    WorkOrderId: number;
    RequestedBy: string;
}
export class WorkOrderHistoryEntity {
    AuditLogId: number
    StatusDate: string
    Status: string
    JobId: number
    StatusReason: string
    UpdatedBy: string
    Remarks: string;
}
export class CustomerEntity {
    CustomerId: number;
    CompanyId: number;
    CustomerTypeId: number;
    CustomerName: string;
    CustomerType: string;
    ClliCode: string;
    PrefContactMode: string;
    Email: string;
    Phone1: string;
    Phone2: string;
    Fax: string;
    ZipCode: string;
    CustomerStatus: string;
    NetworkType: string;
    Node: string;
    ProjectName: string;
    ProjectId: number;

    BillingCustomerId: number;
    Model: string;
    ModelId: number;
    Brand: string;
    BrandId: number;
    SerialNo: string;
    Description: string;
    TagNo: string;
    ContractStartDate: string;
    ContractEndDate: string;
    SlaDays: number;
    SlaHours: number;
    SlaMinutes: number;
    WBSno: string;
    PriorityId: number;
    Durationstr: string;
    PriorityColor: string;
    Duration: number;
    CustomerAddressId: number;
    tContractStartDate: string;
    tContractEndDate: string;
    ProjectStartDate: string;
    ProjectEndDate: string;
    tProjectStartDate: string;
    tProjectEndDate: string;
    PriorityName: string;
    IsNetwork?: number;
    HolidayTemplateId?: number;
    IsCustomerTypeBusinessHour?: number;
    AddressName: string;
    PMName: string;
    BusinessOwner: string;
    ProjectStatus: string;
    IsAllVendorMapped: number;
    Zone: string;
    Region: string;
}

export class CustomerAddressDetails {
    CustomerName: string;
    CustomerAddressId: number;
    CompanyId: number;
    AddressName: string;
    CustomerId: number;
    AddressTypeId: number;
    IsPrimary: number;
    AddressLine1: string;
    AddressLine2: string;
    CityName: string;
    StateName: string
    StateId: number;
    ZipCode: string;
    CountryId: number;
    CountryName: string;
    StateShortName: string;
    UserLat: number;
    UserLon: number;
    UnitNo: number;
    Active: number;
    ZipLat: number;
    ZipLon: number;
    MapLat: number;
    MapLon: number;
    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy: number;
    LastUpdate: string;
    IsActive: number;
    RegionId: number;
    ChangePrimary: number;
    CopyAddress: number;
    CopyBillingAccount: number;
    AcctualAddress: string;
    woId: number;
    woAddressId: number;
    WoContactId: number;
    BillingAddressId: number;
    BillingCustomerId: number;
    billingType: string;
    billingAccountId: number;
    WoFlag: number;
    CustomerContactDetails: CustomerContactDetails[];
    CreatedSourceId?: number;
    UpdatedSourceId?: number;

}

export class CustomerContactDetails {
    CustomerContactId: number;
    CompanyId: number;
    CustomerId: number;
    CustomerAddressId: number;
    AddressTypeId: number;
    Phone1: string;
    Active: number;
    Phone2: string;
    Email: string;
    IsPrimary: number;
    TitleId: number;
    FirstName: string;
    MiddleInitial: string;
    LastName: string;
    ContactTypeId: number;
    Fax: string;
    IsActive: number;
    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy: number;
    LastUpdate: string;
    ContactType: string;
    TitleName: string;
    ChangePrimary: number;
    woId: number;
    WoContactId: number;
    woAddressId: number;
    ActualContact: string;
    contactWoFlag: number;
    CreatedSourceId?: number;
    UpdatedSourceId?: number;
    ActualContactName: string;
}
/**Country List for Dropdown */
export class CountryList {
    CountryId: number;
    CountryName: string;
    Description: string;
    IsActive: Boolean;
    LastUpdate: Date;
}
/**Config values */
export class RefConfigvalue {
    ConfigDtlId: number;
    Description: string;
}
/**Model for Region Dropdown */
export class RefRegion {
    RegionId: number;
    Region: string;

}
/**Model for Special instructions */
export class Specialinfo {
    tempId: number;
    NotesID: number;
    NotesMasterId: number;
    PrimaryKeyId: number;
    CompanyId: number;
    Note: string;
    CreatedBy?: number;
    Name: string;
    CreatedDate: string;
    LastChangedBy?: number;
    LastUpdate?: string;
    CreateUpdateDate?: string;
    Jobno: number;
    jobval: string;
    LastChangedByName: string;
    CreatedByName: string;
    CreatedSourceId: number;
    UpdatedSourceId: number;

}

/**Equipment List Model */
export class equipmentList {
    equipNo: number;
    BrandId: number;
    BrandName: string;
    Model: string;
    ModelId: number;
    SerialNo: string;
    TagNo: string;
    Description: string;
    CustomerEquipmentId: number;
    CustomFieldEntity: CustomFieldsConfiguration;
    ContractStartDate?: string;
    ContractEndDate?: string;
    ContractTypeId: number;
    ManufactureDate?: string;
    WarrantyExpiryDate?: string;
    InstallationDate?: string;
    tContractStartDate: string;
    tContractEndDate: string;
    tInstallationDate: string;
    tManufactureDate: string;
    tWarrantyExpiryDate: string;
    IsContractExpiredColor: string;
    CustomerAddressId: number;
    PriorityId?: number;
    Duration: number;
    Durationstr: string;
    PriorityColor: string
    isExistEquipment: number;



    ResponseSlaStartsFrom: number;
    RespCutOffTimeZoneId: number;
    RespCutOffTime: string;
    ReslCutOffTime: string;
    ReslCutOffTimeZoneId: number;
    SlaStartsFrom: number;
    RespSLADurationTypeId?: number;
    ReslSLADurationTypeId?: number;
    CalcTypeId: number;
    ExcludeHolidays: number;
    HolidayTemplateTypeId: number;
    TotalDuration: number;
    //  IsExisting: number;
    respMaxdate: any;
    reslMaxdate: any;
}
/**Work Order  */

export class WOCategory {
    WoCategoryId: number;
    CompanyId: number;
    WoCategory: string;
    Description: string;
    IsDefault: number;
    IsActive: number;
    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy?: number;
    LastUpdate: string;
}
export class WOPriority {
    PriorityId: number;
    CompanyId: number;
    PriorityName: string;
    Description: string;
    Color: string;
    SlaDays: number;
    SlaHours: number;
    SlaMinutes: number;
    SlaStartsFrom: number;
    SlatStopStatusId: number;
    IsActive: number;
    CreatedBy?: number;
    CreatedDate: string;
    LastChangedBy?: number;
    LastUpdate: string;
    IsDefault: number;
    Duration: number;
    IsResponseSlaEnabled?: number;
    IsResolutionSlaEnabled?: number;
    respreslstring: string;
    SLAtype: string;
    SLADropdown: string;
    SLADropdownlist: string;
    RespSLADurationTypeId?: number;
    ReslSLADurationTypeId?: number;
    ResponseSlaDays?: number;
    ResponseSlaHours?: number;
    ResponseSlaMinutes?: number;
    RespSLADurationType: string;
    ReslSLADurationType: string;
    ReslCutOffTimeZone: string;
    RespCutOffTimeZone: string;

    //----

    ResponseSlaStartsFrom: number;
    RespCutOffTimeZoneId: number;
    RespCutOffTime: string;
    ReslCutOffTime: string;
    ReslCutOffTimeZoneId: number;
    CalcTypeId: number;
    ExcludeHolidays: number;
    HolidayTemplateTypeId: number;




}


export class PriorityListEntity {
    Prioritys: WOPriority[];
    TotalRecord: number;
}

export class JobDetails {
    TaskNumber: number;
    WorkTypeId: number;
    WorkType: string;
    WorkTask: string;
    WorkTaskId: number;
    Duration: string;
    DurationDay: string;
    DurationHour: string;
    DurationMin: string;
    PreferredDate: string;
    PreferredDateFormat: string;
    PreferredTime: number;
    Cost: string;
    TechCost: number;
    CustomerPrice: number;
    reserveId: number;
    categoryId: number;
    priorityId: number;
    requestedBy: string;
    DriveTimeReq: number;
    IsAutoSchedule: number;
    slastartsfrom: number;
    sladay: number;
    slashour: number;
    slasmin: number;
    HoursPerTask: number;
    MinutesPerTask: number;
    WorkGroupId: number;
    CustomFieldEntity: CustomFieldsConfiguration;
    PriceIndex: number;
    Color: string;
    Index: number;
    TaxTypeId: number;
    TaxIdGroupId: number;
    Percentage: number;
    Tax: string;
    SlaPriorityId: number;
    SlaDuration: number;
    Qty: number;
    respMaxdate: any;
    reslMaxdate: any;
    PricingUnitId: number;
    PricingUnit: string;
}


export class JobDetailsPricing {
    TaskNumber: number;
    WorkTypeId: number;
    WorkType: string;
    WorkTask: string;
    WorkTaskId: number;
    categoryId: number;
    priceTypeId: number;
    priceIndx: number;
}

export class WOWorkType {
    WorkTypeId: number;
    WorkType: string;
    description: string;
    PriorityId: number;
}

export class WOWorkTask {
    WorkTypeId: number;
    WorkTaskId: number;
    WorkTask: string;
    Description: string;
    Cost: string;
    TechCost: number;
    CustomerPrice: number;
    AddDriveTime: number;
    IsAutoSchedule: number;
    DaysPerTask: number;
    HoursPerTask: number;
    MinutesPerTask: number;
    WorkGroupId: number;
    TaxTypeId: number;
    TaxIdGroupId: number;
    PricingUnitId: number;
    PriorityId: number;
}

export class JobPricing {
    taskIndex: number;
    workTaskId: number;
    workTypeId: number;
    description: string;
    qty: any;
    unitPrice: any;
    NetTotal: any;
    JobTotal: any;
    discount: any;
    discounttype: number;
    total: any;
    priceTypeId: number;
    priceIndx: number;
    wojobpriceid: number;
    DiscountTypeId: number;
    TaxTypeId: number;
    TaxIdGroupId: number;
    Percentage: number;
    Tax: string;
    TaxFormat?: any;
    NetTotalFormat?: any;
    PricingUnitId: number;
    DurationDay: number;
    DurationHour: number;
    DurationMin: number;
    Warranty: number;
    PricingUnit: string;
    QtyDuration: string;
}
export class EditJobPricing {
    taskIndex: number;
    WorkTaskId: number;
    WorkTypeId: number;
    Description: string;
    Qty: any;
    UnitPrice: any;
    NetTotal: any;
    JobTotal: any;
    Discount: any;
    DiscountTypeId: number;
    total: any;
    priceTypeId: number;
    priceIndx: number;
    wojobpriceid: number;
    TaskNo: number;
    TaxTypeId: number;
    TaxIdGroupId: number;
    PricingUnitId: number;
}

export class WOCalendarSlotProp {
    slotId: number;
    slotName: string;
    slotStartTime: string;
    slotEndTime: string;
    slotColor: string;
    sTempId: number;
    reserveDate: string;
    techScheduleId: number;
    startTime: string;
    WoTaskIds: string[];
    ScheduleStartDate: string;
    ScheduleEndDate: string;
    CustScheduleStartDate: string;
    CustScheduleEndDate: string
}

export class WOCalendarSlot {
    slotProperty: WOCalendarSlotProp[];
}

export class CalendarSlots {
    SlotId: number;
    SlotTime: string;
}

export class CalendarHeader {
    day: string;
    date: string;
    icon: any;
}

export class AppointSlotReserve {
    poreserveid: number;
    poerrorcode: string;
    poseverity: number;
}

/**End of Create Work Order  */

/**Work Order Details */
export class CustomerTypesEntity {
    CustomerTypeId: number;
    CompanyId: number;
    CustomerType: string;
    Description: string;
    IsActive: number;
    IsNetwork: number;
}

export class TimezoneEntity {
    TimeZoneId: number;
    TimeZoneDesc: string;
    TimeZoneCode: string;
}

export class WoStatusComp {
    WoStatusCompId: number;
    WoStatus: string;
}
export class WoStatus {
    WoStatusId: number;
    WoStatus: string;
}
export class Filterworkorder {
    CompanyId: number;
    CustomerTypeId: number;
    CustomerName: string;
    CustomerId: number
    PhoneNumber: number;
    TimeZoneId: number;
    WorkOrderNumber: string;
    WorkOrderId: number;
    CreatedFrom: string;
    CreatedTo: string;
    PriorityId: number;
    WoStatusId: number;
    WoJobId: number;
    ScheduledFrom: string
    ScheduledTo: string
    WorkTypeId: number;
    VendorId: number;
    MaxRoleGroup: number;
    LoginvendorId: number;
    LoginId: number;
    IsPM: number;

    IsActive: number;
    SortBy: string;
    OrderBy: string;
    startRecord: number;
    EndRecord: number;
    WoCategoryId: number;
    SearchText: string;
    ProjectId: any;
    RequestedBy: string;
    WoCategory: string;
    IsCustomerWO: number;
    CPRequestStatusId: number;
}

export class ManageWorkOrderList {
    ManageWorkOrder: ManageWorkOrderEntity[];
    TotalRecord: number;
}
export class FilterDetailsEntity {
    constructor(public FilterName: string,
        public FilterValue: string) { }
}
export class ManageWoListFilterEntity {
    ManageWorkOrder: ManageWorkOrderEntity[];
    Filters: FilterDetailsEntity[];
    LoginId: number;
    CompanyId: number;
    ColumnNames: string;
}
export class ManageWorkOrderEntity {
    WorkOrderId: number;
    WoNumber: string;
    CustomerName: string;
    CustomerId: number;
    TimeZoneId: number;
    TimeZoneCode: string;
    Zone: string;
    RegionId: number;
    Region: string;
    CustomerTypeId: number;
    CustomerType: string;
    ServiceContactId: number;
    Phone1: string;
    WoStatusId: number;
    WoStatus: string;
    WoStatusColor: string;
    CreatedDate: string;
    DateFormat: string;
    PriorityId: number;
    WoCategoryId: number;
    ServiceAddressId: number;
    WoServAddressId: number;
    ServiceAddress: string;
    IsPmOrder: number;
    CustomPanel: string;
    PanelName: string;
    RequestedBy: string;
    WOAddressId: number;
    WoContactId: number;
    ProjectName: string;
    ProjectId: number;
    CPRequestStatus: string;
    CPRequestStautsId: number;
    ClliCode: string;
    ClientPortalLoginId: number;
    CPStatusColor: string;
    isRowSelected: boolean;
    ContactName: string;
    QuoteNumber: string;
    QuoteOrderId: number;
    IsAddressEdit: number;
}
export class WorkTypesEntity {
    WorkTypeId: number;
    WorkType: string;
}
export class WorkCategory {
    WoCategoryId: number;
    WoCategory: string;
}
export class Vendor {
    VendorId: number;
    VendorName: string
    IsPrimaryVendorId: number;
}
export class Wo_JobDetails {
    WoJobId: number;
    TaskNo: number;
    WorkType: string;
    WorkTask: string;
    Days: number;
    Hours: number;
    Minutes: number;
    ApptPrefDate: string;
    ApptPrefTime: string;
    reserveDate: string;
    ScheduleDate: string;
    TechId: number;
    LastTechId: number;
    DisplayName: string;
    WorkOrderId: number;
    JobStatusId: number;
    JobStatus: string;
    WorkTypeId: number;
    WorkTaskId: number;
    WoJobDetailsId: number;
    SlotStartTime1: string;
    SlotEndTime1: string;
    SlotStartTime2: string;
    SlotEndTime2: string;
    WorkGroupId: number;
    WoStatusId: number;
    SlotId: number;
    IsTechnician: boolean;
    ApptPrefDateo: string;
    VendorId?: number;
    ScheduleStartDateTime: string;
    ScheduleEndDateTime: string;
    VendorName: string;
    VendorAssignRemarks: string;
    SlotName1: string;
    IsEdit: boolean;
    AllowSelfAssign: number;
    custaddressid: number;
    StatusReason: string;
    Issubmitted?: boolean;
    EnableOptimization: number;
    PmScheduleId: number;
}
export class AupWoAppointment {
    piWoJobId: number;
    piTechId: number;
    piWorkDate: string;
    piStartTime: string;
    piEndTime: string;
    piTravelTime: number;
    piDistance: number;
    piComments: string;
    piIsConfirm: number;
    piCompanyId: number;
    piLoginId: number;
    piVendorId: number;
    scheduled: number;
    piArrivalTime: string;
    PiSourceId?: number;
    workStartDate: string;
    workEndDate: string;
    piNextJobStartTime: string;
    piNextJobId : number;
    piNextJobTravelTime : number;
    piNextJobDistance: number;
}
export class SchCustomerDetails {
    customerId: number;
    customerName: string;
    serviceAddress: string;
    contactName: string;
    contactPhone: string;
    jobId: string;
    jobDuration: string;
    preferredTime: string;
    emit: boolean;
    preferredDate: string;
    jobStatusId: number;//added for senthilg
    vendorId?: number;
}
export class TechWorkSchFilter {
    PiWoJobId: number;
    PiSkillMatchReq: number;
    PiRegionMatchReq: number;
    PiCertificationMatchReq: number;
    PiWorkTypeMatchReq: number;
    PiAllowOverTime: number;
    PiShowTechniciansAround: number;
    PiTechnician: string;
    PiSortBy: number;
    PiStartDate: string;
    PiScheduleRange: number;
    PiLoginId: number;
    PiCompanyId: number;
    PiTechid: number;
    PiVendorId: number;
    TechEmail: string;
    NextJobStartTime:string;
    NextJobId: number;
    NextJobTravelTime: number;
    NextJobDistance: number;
}
export class TechWorkScheduleDetail {
    TechWorkSchedule: TechWorkSchedule[];
    poIsTechPrefConfigAvailable: number;
}
export class TechWorkSchedule {
    TechId: number;
    TechName: string;
    Distance: number;
    TravelTime: number;
    VendorName: string;
    Region: string;
    AvailableHours: string;
    AvailableDate: string;
    AllocatedHours: string;
    ArrivalTime: string;
    IsManager: boolean;
    EndTime: string;
    Status: boolean;
    VendorId: number;
    StartTime: string;
    AvailableStartTime: string;
    AvailableEndTime: string;
    Availabletimes: string;
    AvailableHoursStart: string;
    AvailableHoursEnd: string;
    TechPreferenceId: number;
    NextJobStartTime:string;
    NextJobId: number;
    NextJobTravelTime: number;
    NextJobDistance: number;
}
export class Technician {
    Email: string;
    LoginId: number;
    FirstName: string;
    LastName: string;
    DisplayName: string;
    Phone1: number;
    Phone2: number;
    Designation: string;
    ManagerId: number;
    UniquRefNo: string;
    Roles: string;
    Manager: string;
    Zones: string;
    Regions: string;
    IsActive: number;
    VendorId: number;
}
export class WoJobAdd {
    WoJobId: number;
    CompanyId: number;
    WorkOrderId: number;
    ApptPrefDate: string;
    ApptPrefSlotId: number;
    ApptPrefTime: string;
    Days: number;
    Hours: number;
    Minutes: number;
    WorkTypeId: number;
    WorkTaskId: number;
}
export class woJobCFModel {
    AddEditWoJobEntity: AddEditWoJobEntity;
    CustomFieldEntity: CustomFieldsConfiguration;
    JobPricing: JobPricing[];

}

export class UpdateWorkorderCFModel {
    updworkOrderDetail: updateworkOrderDetail;
    CustomFieldEntity: CustomFieldsConfiguration;


}
export class updateworkOrderDetail {
    CompanyId: number;
    WorkOrderId: number;
    PriorityId: number;
    WoCatetgoryId: number;
    RequestedBy: string;
    LastChangedBy?: number;
    LastUpdate: string;
}
export class woJobEditCFModel {
    AddEditWoJobEntity: AddEditWoJobEntity;
    CustomFieldEntity: CustomFieldsConfiguration;
    JobPricing: EditJobPricing[];

}
export class AddEditWoJobEntity {
    WoJobId: number;
    CompanyId: number;
    WorkOrderId: number;
    ApptPrefDate: string;
    ApptPrefSlotId: number;
    ApptPrefTime: string;
    LastChangedBy: number;
    LastUpdate: string;

    WoJobDetailsId: number;
    WorkTypeId: number;
    WorkTaskId: number;
    Days: number;
    Hours: number;
    Minutes: number;
    TaskNo: number;
    CreatedBy: number;
    CreatedDate: string;
    CustomerPrice: number;
    VendorId: number;
    WorkGroupId: number;
    CreatedSourceId?: number;
    UpdatedSourceId?: number;
    CustomerTypePriorityId: number;
    WorkTypePriorityId: number;
    IsCustPrefDateChanged?: number;
    CustomerId: number;
    Qty: number;
}
export class OnHoldStatus {
    CustomerId: number;
    StatusReason: string;
}


export class SchedulingPreference {

    CompanyId: number;

    VariableCompId: number;

    ScheduleVariableId: number;

    PreferenceValue: number;

    IsEnabled: number;

    VariableGroupId: number;

    VariableName: string;

    VariableOption: string;

    IsActive: number;

    ManualSchdOverridable: number;

    DispatchBrdOverridable: number;

    LastChangedBy: number;

}
export class ClosurePendingDetails {
    JobNo: number;
    ApprovalBy: string;
    ApprovalDate: string;
    ApprovedBy: string;
    InvoiceBy: string;
    InvoiceById: string;
    InvoiceDate: string;
}
export class SearchWorkOrder {
    WorkOrderId: number;
    CustomerId: number;
    WoNumber: string;
    WoStatusId: number;
    WoJobId: number;
    WoCategoryId: number;
    TechId: number;
}

export class Wojobstatus {
    CompanyId: number;
    Remarks: string;
    WojobId: number;
    StatusId: number;
    loginId: number;
    CancelReasonId: string;
    WorkOrderId: number;
}
export class CancelWOstatus {
    CompanyId: number;
    Remarks: string;
    WojobId: number;
    StatusId: number;
    loginId: number;
    CancelReasonId: string;
    WoOrderId: number;
}

export class WoaddressDetails {

    WoAddressId: number;
    CompanyId: number;
    WorkOrderId: number;
    AddressName: string;
    CustAddressId: number;
    AddressTypeId: number;
    AddressLine1: string;
    AddressLine2: string;
    UnitNo: string;
    CityName: string;
    StateId: number;
    ZipCode: string;
    CountryId: number;
    UserLat: number;
    UserLon: number;
    ZipLat: number;
    ZipLon: number;
    MapLat: number;
    MapLon: number;
    IsPrimary: number;
    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy: number;
    LastUpdate: string;
    WoContactEntity: WoContact[];
}

export class WoContact {

    WoContactId: number;
    CompanyId: number;
    WorkOrderId: number;
    WoAddressId: number;
    CustContactId: number;
    AddressTypeId: number;
    TitleId: number;
    FirstName: string;
    MiddleInitial: string;
    LastName: string;
    Phone1: string;
    Phone2: string;
    IsPrimary: number;
    Fax: string;
    Email: string;
    ContactTypeId: number;
    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy: number;
    LastUpdate: string;
}
/**End of Work Order Details */

export class Email {
    SentDate: string;
    EmailFrom: string;
    Subject: string;
    ToEmail: string;
    CcEmail: string;
    ToNumber: string;
    BodyContent: string;
    Sender: string;
}

export class PartRequest {
    WoJobId: number;
    PartNo: string;
    PartRequestNo: string;
    Description: string;
    Warehouse: string;
    RequestedQty: number;
    IsActive: number;
    IsSerialized: number;
    RequestStatusId: number;
    PartId: number;
    WarehouseId: number;
    SerialNo: SerialNumber[];

    UomId: number;
    MovingCost : number;
    UnitPrice: string;
    Uom: string;

    PartNotes: string;
    IsOEM: number;
    IsCoreReturn: number;
    OEMName: string;
    OrderNo: string;
    ShipVia: string;
    ShippingDate: string;
    TrackingNo: string;
    ETADate: string;
    ETATime: string;
    RMANo: string;
    RMATrackingNo: string;
    RMAShippingDate: string;
    RMANotes: string;
    WoPartPriceId: number;
    TaxTypeId: number;
    TaxIdGroupId: number;
    CoreReturnStatusID: number;
    CoreReturnNotes: string;
    PartReqStatusId: number;
    PartRequestId: number;
    Status: boolean;
    DropPoint: string;
    OEMPartReqTypeId: number;
    ReceivedOn: string;
    Attachement: string;
    //BOQ --
    RejectReason: string;
    IsBOQRequest: number;
    VendorId: number;
    ApproveReason: string;
    ApprovedQty: string;
    VendorName: string;
    BrandId: number;
    ModelId: number;
    ApprovalStatusId: number;
    WarrantyMonths: number;
    BOQTechId?: number;
    JobStatusId?: number;
    // -- BOQ 
}

export class PartRequestEntity {
    WoJobId: number;
    PartNo: string;
    PartRequestNo: string;
    Description: string;
    PartReqStatus: string;
    RequestedQty: number;
    PartId: number;
    PartReqStatusId: number;
    PartRequestId: number;
    Status: boolean;
    AttachmentExists: number;
    IsEdit?: boolean;
    ApprovalStatus: string;
    ApprovalStatusId: number;
    IsBOQRequest?: number;
    VendorId?: number;
    ApproveReason: string;
    ApprovedQty?: number;
    BOQDescription?: string; //Using UI
}

export class PartRequestListEntity {
    PartLists: PartRequestEntity[];
    TotalRecord: number;
}

export class Job {
    WoJobId: number;
    JobStatusId: number;
}


export class PartLookup {
    PartId: number;
    PartNo: string;
    Brand: string;
    BrandId: number;
    Description: string;
    Model: string;
    ModelId: number;
    IsActive: number;
    IsSerialized: number;
    Category: string;
    PartType: string;
    Status: string;
    Serialized: string;
    UomId: number;
    MovingCost : number;
    UnitPrice: string;
    Uom: string;
    TaxTypeId: number;
    TaxIdGroupId: number;
    AttachmentExists: number;
    VendorPrice?: number;
}
export class PartLookupList {
    PartLookupLists: PartLookup[];
    TotalRecord: number;
}

export class PartLookupFilter {
    CompanyID: number;
    BrandId: number;
    ModelId: number;
    PartNo: string;
    Description: string;
    SortBy: string;
    OrderBy: string;
    StartRecord: number;
    EndRecord: number;
    WhId: number;
    SerialNo: string;
    PartId: number;
    vendorId: number;


}

export class PartWareHouse {
    WarehouseId: number;
    Warehouse: string;
    count: number;
}

export class BrandList {
    BrandId: number;
    Brand: string;

}

export class ModelList {
    ModelId: number;
    Model: string;

}

export class SerialNumberCount {
    SerialNumbers: SerialNumber[];
    cnt: number;
}

export class SerialNumber {
    SerialNo: string;
    ExpiryDate: string; // Warranty Expiry Date for Serial # - Changes Coulmn Added by KP on 17/08/2020
}

// export class AllocatePart {
//     CompanyId: number;
//     WorkOrderId: number;
//     JobId: number;
//     PartRequestId: number;
//     PartId: number;
//     ReqQty: number;
//     WhId: number;
//     IsSerialized: number;
//     loginid: number;
//     SerialNo: SerialNumber[];
// }

export class AllocatePart {
    CompanyId: number;
    WorkOrderId: number;
    JobId: number;
    PartRequestId: number;
    PartId: number;
    ReqQty: number;
    PartNotes: string;
    IsOEM: number;
    IsCoreReturn: number;
    OEMName: string;
    OrderNo: string;
    ShipVia: string;
    ShippingDate: string;
    TrackingNo: string;
    ETADate: string;
    ETATime: string;
    RMANo: string;
    RMATrackingNo: string;
    RMAShippingDate: string;
    RMANotes: string;
    WhId: number;
    IsSerialized: number;
    loginid: number;
    SerialNo: SerialNumber[];
    RequestStatusId: number;
    PartOEM: number;
    SourceID: number;
    CreatedBy: number;
    CoreReturnStatusID: number;
    CoreReturnNotes: string;
    partPricing: PartPricing;
    DropPoint: string;
    OEMPartReqTypeId: number;
    ReceivedOn: string;
    Attachement: string;
    MovingCost : number;
}
export class WoSLAHistory {
    WoJobId: number;
    SLAStartTime: string;
    SLAEndTime: string
    IsSLAMet: number;
    CreatedDate: string
    ApptPrefDate: string;
    Duration: number;
    Durationstr: string;
    PriorityName: string;
    PriorityId: number;
    Color: string;
    JobStatusId: number;
    ActualSLAEndTime: string;
    SLAType: string;
    SLATypeId: number;
    ShowSlaTimer: number;
    SLAApplied: number;
    ResolutionSLADurationType: string;
    ResponseSLADurationType: string;
    RespSLADurationTypeId: number;
    ReslSLADurationTypeId: number;
    isEdit: boolean;
}
export class WoJobSLAHistoryDetail {
    WoJobId: number;
    SLAStartngTime: string;
    SLAStartTime: string;
    SLAEndTime: string;
    IsSLAMet: number;
    CreatedDate: string
    ApptPrefDate: string;
    Duration: number;
    PriorityName: string;
    Durationstr: string;
    SLADurationType: string;
    SLADurationTypeId: number;
}
export class SLAEntity {
    piJobId: number;
    piCompanyid: number;
    piPriorityID: number;
    piAutoProcess: number;
    poErrorCode: string;
    piloginid: number;
    piIsChangedbycustomer: number;
    PiSourceId?: number;
    piSLAApplied?: number;
    PiIsCustPrefDateChanged?: number;
}

export class WoJobSLAHistoryEntityList {
    WoJobSLAHistoryDetail: WoJobSLAHistoryDetail[];
    TotalRecord: number;
}
export class WoSLADetails {
    WoJobId: number;
    SortBy: string;
    OrderBy: string;
    startRecord: number;
    EndRecord: number;
    CompanyId: number;
    SLATypeId: number;
}
export class SpErrors {
    PoErrorCode: string;
    PoSeverity: number;
    poErrorMsg: string;
}


export class PartReqStatus {
    RequestStatusId: number;
    PartReqStatus: string;

}
export class CoreReturnStatus {
    CoreReturnStatusId: number;
    CoreReturnStatus: string;

}
export class confirmationpopup {
    mtype: number;
    mheader: any;
    mcontent: any;
    mfooter: boolean;
}
export class CompanyWeekends {
    IsSundayWeekEnd: number;
    IsMondayWeekEnd: number;
    IsTuesdayWeekEnd: number;
    IsWednesdayWeekEnd: number;
    IsThursdayWeekEnd: number;
    IsFridayWeekEnd: number;
    IsSaturdayWeekEnd: number;
}
export class DispatchSetting {
    SettingId: number;
    Setting: string;
    SettingValue?: number;
}
export class Holiday {
    HolidayId: number;
    HolidayDate: string;
    IsActive: number;
    HolidayTemplateId: number;
    IsDefault?: number;
}
export class Projects {
    ProjectId: number;
    ProjectName: string;
}
export class Config {
    ConfigDtlId: number;
    Description: string;
    Defaultsettingval: number;
}
export class TransferHistList {
    TransferHistory: TransferHistory[];
    TotalRecord: number;
}
export class TransferHistory {
    CustomerId: number;
    CompanyId: number;
    FromCustomerName: string;
    ToCustomerName: string;
    AddressLine1: string;
    AddressLine2: string;
    UnitNo: string;
    CityName: string;
    StateName: string;
    ZipCode: string;
    CountryName: string;
    StateShortName: string;
    UserLat?: number;
    UserLon?: number;
    ToAddressLine1: string;
    ToAddressLine2: string;
    ToUnitNo: string;
    ToCityName: string;
    ToStateName: string;
    ToZipCode: string;
    ToCountryName: string;
    ToStateShortName: string;
    ToUserLat?: number;
    ToUserLon?: number;
    BrandName: string;
    Model: string;
    SerialNo: string;
    TransferNotes: string;

    FromActulaAddress: string;
    ToActulaAddress: string;
    LastTransferreddate: string;
    TransferredBy: string;
}

//TAX -- Added by Anvardeen Batcha
export class TaxGroup {
    TaxId: number;
    TaxName: string;
    TaxPercent: number;
    TaxValue: string;
    IsActive: number;
}

export class TaxMaster {


    TaxId: number;
    CompanyId: number;
    TaxName: string;
    Description: string;
    TaxAuthorityId: number;
    TaxPercent: number;
    IsActive: number;
    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy: number;
    LastUpdate: string;
    Status: string;

}

export class JobStatusReasonEntity {
    StatusReasons: StatusReasons[];
    TotalRecord: number;
}

export class StatusReasons {
    StatusReasonId: number;
    StatusReason: string;
    JobStatusId: number;
    JobStatus: string;
    RecordType: number;
}




export class SmsLogReceived {
    RecvdSmsLogId: number;
    FromNumber: string;
    ToNumber: string;
    SMSContent: string;
    Percentage: number;
    RecvdDate: string;
    wojobid: number;
    LastUpdate: string;
    DisplayName: string;
    IsRead: number;
    Filepath: string;
    imageStatus: boolean = false;
    Notification: number;
    RecvdTime: string;
    RecvdDateShort: string;
    checkType: string;
    contenttype: string;
    WorkOrderid: number;
    JobStatusId: number;
    toemail: string
    // RecvdSmsLogId: number;
    // FromNumber: string;
    // ToNumber: string;
    // SMSContent: string;
    // Percentage: number;
    // RecvdDate: string;
    // wojobid: number;
    // LastUpdate: string;
    // DisplayName: string;
    // IsRead: number;
    // imageStatus:boolean=false;
    // Filepath:string;
    // Notification:number;
    // RecvdTime:string;
    // RecvdDateShort: string;
}

export class GetSMSLogSearch {
    TechnicianName: string;
    TechnicianMobile: string;
    vendor: string;
    CustomerID: string;
    ProjectID: number;
    JobNo: string;
    WONo: string;
    FromDate: string;
    ToDate: string;

}
export class GetSMSLog {
    // WoJobId: number;
    // wonumber: string;
    // wocategory: string;
    // jobstatus: string;
    // DisplayName: string;
    // phone1: string;
    // vendorname: string;
    // CustomerName: string;
    // ProjectName: string;
    // SMSLogCount: number;
    WoJobId: number;
    wonumber: string;
    wocategory: string;
    jobstatus: string;
    DisplayName: string;
    phone1: string;
    vendorname: string;
    CustomerName: string;
    ProjectName: string;
    SMSLogCount: number;
    WorkOrderid: number;
    JobStatusId: number;
    toemail: string;
}
export class GetSMSLogList {
    GetSMSLogslistentity: GetSMSLog[];
    TotalRecord: number;
}
export class SmslogEntity {
    SmsContent: string;
    tonumber: number;
    WoJobId: number;
    WorkOrderId: number;
    DisplayName: string;
    SourceSystem: string;
    LogType: number;
    CreatedDate: string;

}
export class Pagination {
    CompanyId: number;

    IsActive: number;

    SortBy: string;

    OrderBy: string;

    startRecord: number;

    EndRecord: number;

    SearchBy: string;


}
export class PartPricing {
    TaskNo: number;
    PartRequestId: number;
    description: string;
    qty: any;
    unitPrice: any;
    NetTotal: any;
    JobTotal: any;
    discount: any;
    discounttype: number;
    total: any;
    priceTypeId: number;
    priceIndx: number;
    wopartpriceid: number;
    DiscountTypeId: number;
    TaxTypeId: number;
    TaxIdGroupId: number;
    Percentage: number;
    Tax: string;
    TaxFormat?: any;
    NetTotalFormat?: any;
    LastChangedBy: number;
    CreatedBy: number;
}

export class jobNumber {
    wojobid: number;
}

export class ValidEquipment {
    CompanyId: number;
    BrandId: number;
    ModelId: number;
    SerialNo: string;
    CustomerEquipmentId: number;
    PriorityId: number;
}
export class CPUpdateDetails {
    CPStatusReasonId: number;
    UpdatedSourceLoginId: number;
    CompanyId: number;
    CPRequestStautsId: number;
    CPRemarks: string;
    WorkOrderId: CPUpdateWorkorder[];
    UpdatedSourceId: number;
}

export class CPUpdateWorkorder {
    WorkOrderId: number;
    CustomerTypeId: number;
}

export class CPStatusReasonDD {
    CPStatusReasonId: number;
    CPStatusReason: string;
}
export class RefCPRequestStatusComp {
    CPRequestStatusId: number;
    CPRequestStatus: string;
}
export class RefOEMPartReqType {
    OEMPartReqTypeId: number;
    OEMPartReqType: string;
}
export class Logo {
    fileName: string;
    filePath: string;
    attachment: string;
}


export class CalendarTimeSlots {
    SlotId: number;
    SlotTime: string;
    SlotStartTime: Date;
}

export class BusinessHour {
    CompanyBusinessHourId: number;
    CompanyId: number;
    WeekDay: any;
    DayStartHour: Date;
    DayEndHour: Date;
    IsActive: number;
    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy: number;
    LastUpdate: string;
    Is24Hour: any;
    DayStartHourTag: string;
    DayEndHourTag: string;
}

export class CustomerBusinessHour {
    CustomerBusinessHourId: number;
    CompanyId: number;
    CustomerId: number;
    WeekDay: any;
    DayStartHour: string;
    DayEndHour: string;
    IsActive: number;
    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy: number;
    LastUpdate: string;
    Is24Hour: any;
    DayStartHourTag: string;
    DayEndHourTag: string;
}

export class CTBusinessHour {
    CustomerTypeBusinessHourId: number;
    CompanyId: number;
    CustomerTypeId: number;
    WeekDay: any;
    DayStartHour: string;
    DayEndHour: string;
    IsActive: number;
    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy: number;
    LastUpdate: string;
    Is24Hour: any;
    DayStartHourTag: string;
    DayEndHourTag: string;
}

export class BOQPartsEntity {
    PartRequestId?: number;
    CompanyId: number;
    WorkOrderId: number;
    JobId: number;
    ReqQty: number;
    PartNotes: string;
    loginid: number;
    RequestStatusId: number;
    IsBOQRequest: number;
    VendorId: number;
    BrandId: number;
    ModelId: number;
    PartId: number;
    Price: number;
    SourceID?: number;
    CreatedBy?: number;
    LastChangedBy?: number;
    ApprovalStatusId: number;
    WoPartPriceId: number;
    BOQTechId?: number;
    ApprovedQty?: number;
}
export class GetEMailLogList {
    GetEmailLogslistentity: GetSMSLog[];
    TotalRecord: number;
}

export class LinkedWorkOrders {
    CompanySetting: number;
    IsParentOrder: number;
    IsChildOrder: number;
    //if Parant WO
    ChildWoCount: number;
    //If child
    ParantWoId: number;
    ParantWoCustomerId: number;
    ParantWoNo: string;
}

export class DynamicSaveModel {
    WoJobChecklistDetailId?: number;
    CompanyId?: number;
    WoJobId?: number;
    WoJobChklistId?: number;
    ChklistDtlId?: number;
    FieldTypeId?: number;
    TextValue?: string;
    BooleanValue: number;
    WoChklistDdId?: number;
    CreatedBy?: number;
    CreatedDate?: Date;
    ChklistMastId?: number;
    LastUpdate?: Date;
    LastChangedBy?: number;
    IsOptional: boolean;
    formconName: string;
    ControlType: string;
    Hidden: string;
    ChklistActiveDtl: number;
    CreatedSourceId?: number;
    UpdatedSourceId?: number;
    //CheckBoxList
    MultiCheckBoxControl: number[] = [];
    //CustomField
    CFDropDownId: number;
    DtValue: string;
    FieldSourceId?: number;
    FieldId?: number;
    SubFormParentId?: number;
    PrimaryEntityId?: number;
    ShowAttachment?: number;
    AttachmentCount?: number;
}
export class SaveDynamicChecklist {
    Questions: DynamicSaveModel[] = [];
    CommonData: CommonData;
}

export class CommonData {
    CustomerId: number;
    WorkOrderId: number;
    WoJobId: number;
    CompanyId: number;
}

export class DynamicCheckListDetails {
    WoJobChecklistDetailId: number;
    WoJobId: number;
    CompanyId: number;
    ChklistDtlId: number;
    ChklistMastId: number;
    QuestionId: number;
    Question: string;
    FieldTypeId: number;
    IsOptional: boolean;
    MaxLength: number;
    FieldUnits: string;
    OrderNo: number;
    ChklistDdMastId: number;
    ChklistStatusId: number;
    IsActive: boolean;
    CreatedBy: number;
    Description: string;
    ValueList: string;
    WoJobChklistId: number;
    //dropdownvalues
    dropdownvalues: any[];
    formconName: string;
    ControlType: string;
    TextValue: string;
    BooleanValue: number;
    WoChklistDdId: number;
    ChklistActiveDtl: number;
    AllowAttachment: number;
    ParentQuestionId: number;
    ParentQuestionAnswerId: number;
    MultiCheckBoxControl: number[] = [];
    AttachmentCount: number;
    show: boolean = false;
    WorkOrderId: number;
    //Custom Field Changes
    CFDropDownId: number;
    DtValue: any;
    FieldSourceId?: number;
    FieldId?: number;
    SubFormParentId?: number;
    PrimaryEntityId?: number;
    IsReadOnly?: number;
    SubFormList: DynamicCheckListDetails[];
    SubFormParantQuestion: string = ''; // Only For UI
    IsSubFormQuestion: boolean;
    attachmentDetails: any[];
}

export class ProjectMilestone {
    ProjectMilestoneId: number;
    ProjectMilestone: string;
    IsActive: number;
}